import type {
    AutoAcceptInfo,
    LocateOrder,
    NewLocateOrder,
    NewLocateOrderRequest,
    NewLocateOrderResponse,
} from '@thinkalpha/ui-types/contracts/locates/orders';
import { createInstance } from 'src/api';
import { appConfig } from 'src/lib/config';

const axios = createInstance({ baseURL: appConfig.locatesApi });

export interface CreateLocatesOrderParams {
    order: NewLocateOrder;
    autoAccept?: AutoAcceptInfo;
}

export async function createLocatesOrder(params: CreateLocatesOrderParams): Promise<LocateOrder[]> {
    const { order, autoAccept } = params;
    const { data } = await axios.post<NewLocateOrderResponse>('/orders', {
        order,
        autoAccept,
    } satisfies NewLocateOrderRequest);
    return data.orders;
}
